module.exports = __webpack_public_path__ + "static/media/344c428b-74f6-47bd-9182-2f80f95f4fc5.9d31454e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/344c428b-74f6-47bd-9182-2f80f95f4fc5.png
// module id = 1472
// module chunks = 0